export const googlePlayStore = "GP"
export const appStore = "AS"
export const stores = [
    { store: 'Google Play', abbr: googlePlayStore },
    { store: 'App Store', abbr: appStore },
]